<style lang="less" scoped>
ul,li {margin: 0;padding: 0;list-style: none;}
.gywm {position: relative;width: 100%;display: flex;flex-direction: column;justify-content: center;align-items: center;margin: 0;padding: 0;background: #fff;font-family: AlibabaPuHuiTi-Medium;margin-bottom: 60px;}
.national {width: 1200px;}
.container {width: 1200px;
  .About {margin-top: 20px;margin-left: 0px;text-align: left;height: 40px;margin-bottom: 27px;
    i {float: left;margin-right: 10px;margin-top: 10px;font-size: 19px;color: #49AEE3;}
    h3 {font-size: 18px;line-height: 40px;letter-spacing: 1px;color: #2c3e50;margin: 0px;height: 100%;}
  }
}
/deep/.el-tabs__item {line-height: 62px !important;width: 170px;height: 62px;text-align: center !important;	line-height: 32px;letter-spacing: 1px;color: #000000;font-size: 18px;}
/deep/.el-tabs__item::after {content: '>';margin-left: 10px;position: relative;left: 35px;}
/deep/.is-active {background-color: #0090ff;color: #ffffff;}
/deep/#tab-second {border-top: solid 1px #707070;}
/deep/ .el-tabs--left .el-tabs__nav-wrap.is-left::after, .el-tabs--left .el-tabs__nav-wrap.is-right::after, .el-tabs--right .el-tabs__nav-wrap.is-left::after, .el-tabs--right .el-tabs__nav-wrap.is-right::after {width: 0;}
/deep/.el-tabs--left .el-tabs__active-bar.is-left, .el-tabs--left .el-tabs__active-bar.is-right, .el-tabs--right .el-tabs__active-bar.is-left, .el-tabs--right .el-tabs__active-bar.is-righ {width: 0;}
.first {
  .title {text-align: left;margin-left: 64px;margin-bottom: 42px;
    h1 {margin: 0;padding: 0;font-size: 24px;line-height: 32px;letter-spacing: 1px;color: #000000;}
    p {margin: 0;padding: 0;;font-size: 16px;line-height: 32px;letter-spacing: 1px;color: #000000;}}
  .content {width: 934px;height: 500px;display: flex;flex-direction: row;flex-direction: row;justify-content:space-between;margin-left: 64px;
    .right {
      .txt {margin: 0px 23px;font-size: 16px;line-height: 32px;letter-spacing: 0px;color: #000000;overflow: hidden;height: 480px;text-align: left;text-indent: 2em;}
      .el-button{margin: 10px auto;}
    }
  }
}
.firstbottom {margin-bottom: 20px;
  .title {text-align: left;margin-left: 64px;margin-top: 42px;
    h1 {margin: 0;padding: 0;font-size: 24px;line-height: 32px;letter-spacing: 1px;color: #000000;}
    p {margin: 0;padding: 0;;font-size: 16px;line-height: 32px;letter-spacing: 1px;color: #000000;}
  }
  .contentTop {width: 1200px;height: 500px;margin: 0px auto;position: relative;background: #ccc;
    .avatar {width: 100px;height: 100px;border-radius: 50%;background: yellow;margin: 0 auto;overflow: hidden;display: block;position: absolute;text-align: center;}
    .box {width: 200px;height: 200px;background-color: #f40;border-radius: 50%;position: relative;top: 150px;left: 550px;}
  }
}
.second {
  .title {text-align: left;margin-left: 64px;margin-bottom: 42px;
    h1 {margin: 0;padding: 0;font-size: 24px;line-height: 32px;letter-spacing: 1px;color: #000000;}
    p {margin: 0;padding: 0;;font-size: 16px;line-height: 32px;letter-spacing: 1px;color: #000000;}
  }
  .infoCard{ margin-left: 64px;width: 337px;height: 610px;box-sizing: border-box;text-align: left;
    .description{font-size: 18px;font-weight: 600;margin-left: 30px;}
    .value{font-size: 18px;}
  }
}
// /deep/.video{height: 327px;width: 518px;}
/deep/.video-js .vjs-big-play-button{top: 45%;left: 45%;}
/deep/.video-player > div {height: 90%;width: 87%;margin-left: 86px;}
</style>

<template>
  <div class="gywm">
    <National></National>
    <div class="container">
      <div class="About">
        <i class="iconfont icon-fenlei_"></i>
        <h3>关于我们 / About us</h3>
      </div>
      <el-tabs v-model="activeName"  :tab-position="tabPosition">
        <el-tab-pane label="平台简介" name="first">
          <div class="first">
            <div class="title">
              <h1>平台简介</h1>
              <p>Introduction</p>
            </div>
            <div class="content">
              <!-- <div class="left">
                <div class="video">
                  <video-player
                    ref="videoPlayer" :playsinline="true"  :options="playerOptions">
                  </video-player>
                </div>
              </div> -->
              <div class="right">
                <div class="txt">{{this.gywmlist[0].introduce}}</div>
                <!-- <el-button type="primary" v-if="!show" @click="dialogVisible = true">查看更多</el-button>
                <el-button type="primary" v-if="show" @click="lookmore">收起</el-button> -->
              </div>
            </div>
          </div>
          <div class="firstbottom">
            <!-- <div class="title">
              <h1>中心架构</h1>
              <p>Framework</p>
            </div> -->
            <div class="video">
              <video-player
                ref="videoPlayer" :playsinline="true"  :options="playerOptions">
              </video-player>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="联系方式" name="second">
          <div class="second">
            <div class="title">
              <h1>联系方式</h1>
              <p>contact information</p>
            </div>
            <div class="infoCard">
              <p><span class="description">电&nbsp;&nbsp;&nbsp;话：</span><span class="value">{{this.gywmlist[0].phone}}</span></p>
              <p><span class="description">传&nbsp;&nbsp;&nbsp;真：</span><span class="value">{{this.gywmlist[0].fax}}</span></p>
              <p><span class="description">邮&nbsp;&nbsp;&nbsp;箱：</span><span class="value">{{this.gywmlist[0].email}}</span></p>
              <p><span class="description">地&nbsp;&nbsp;&nbsp;址：</span><span class="value">{{this.gywmlist[0].address}}</span></p>
              <p><span class="description">邮&nbsp;&nbsp;&nbsp;编：</span><span class="value">{{this.gywmlist[0].zipcode}}</span></p>
              <p><span class="description">联系人：</span><span class="value">{{this.gywmlist[0].contacts}}</span></p>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog
      title="简介详情"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose">
      <span>{{this.gywmlist[0].introduce}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import National from '../assembly/National'
import playVideo from '../method/playVideo'
export default {
  components: {
    National
  },
  mixins: [playVideo],
  data()
  {
    return {
      widthCSH: 518,
      heightCSH: 327,
      swiperlist: [],
      gywmlist: [],
      activeName: 'first',
      tabPosition: 'left',
      show: false,
      dialogVisible: false
    }
  },
  created()
  {
    this.playerOptions.sources[0].src = '../../../../static/gywm.mp4'
    this.getKylt()
    this.getGywm()
  },
  computed:
  {
    Swiperlist()
    {
      return this.swiperlist
    }
  },
  methods: {
    getKylt()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 5, _exp: 'id>0 and examine = 0', orderby: 'id DESC', init: 0, pageno: 1, pagesize: 9}
      window.post.getPost(paras).then((ret) =>
      {
        for (let i = 0; i < ret[0].data.length; i++)
        {
          if (i < 3)
          {
            if (!ret[0].data[i].thumb)
              ret[0].data[i].thumb = 'static/images/moren.jpg'
            this.swiperlist.push({id: ret[0].data[i].id, pic: ret[0].data[i].thumb, title: ret[0].data[i].title})
          }
        }
      })
    },
    getGywm()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 114, _exp: 'id>0', orderby: 'id DESC', init: 0, pageno: 1, pagesize: 1}
      window.post.getPost(paras).then((ret) =>
      {
        this.gywmlist.push({id: ret[0].data[0].id, introduce: ret[0].data[0].introduce, phone: ret[0].data[0].phone, fax: ret[0].data[0].fax, email: ret[0].data[0].email, address: ret[0].data[0].address, zipcode: ret[0].data[0].zipcode, contacts: ret[0].data[0].contacts, thumb: ret[0].data[0].thumb})
        this.playerOptions.sources[0].src = ret[0].data[0].video
        // for (let i = 0; i < ret[0].data.length; i++)
        // {
        //   if (i < 3)
        //   {
        //     if (!ret[0].data[i].thumb)
        //       ret[0].data[i].thumb = 'static/images/moren.jpg'
        //     this.swiperlist.push({id: ret[0].data[i].id, pic: ret[0].data[i].thumb, title: ret[0].data[i].title})
        //   }
        // }
      })
    },
    handleClick(tab, event)
    {
    },
    goDetails(item)
    {
    },
    //加载更多
    lookmore()
    {
      this.show = !this.show
      if (this.show)
      {
        $('.txt').css('height', 'auto')
        $('.txt').css('min-height', '278px')
      }
      else
        $('.txt').css('height', '278px')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/Gywm.vue